export default __webpack_public_path__ + "static/B0233-950d5379133ef45c22687d22cb215ee1.png";